var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.3634 31.3255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8623,22.2615c.1713-.4583-.1367-.7486-.5691-1.08a6.105,6.105,0,0,1,.5735-9.9433.42.42,0,0,0,.2262-.5862A5.99,5.99,0,0,1,7.2277,3.1381a5.132,5.132,0,0,1,2.9832.1007c.2758.0937.3715.0258.509-.2151a5.58,5.58,0,0,1,9.9258.011c.1018.18.1473.3158.4309.2283a5.6644,5.6644,0,0,1,7.2422,4.174,6.12,6.12,0,0,1-.0824,3.3059.3089.3089,0,0,0,.16.4372,6.0933,6.0933,0,0,1,.2983,10.2689c-.2281.1585-.2156.3258-.2082.5388a5.8922,5.8922,0,0,1-2.8846,5.5806,5.1731,5.1731,0,0,1-4.4435.5193c-.3009-.095-.3953-.0082-.5337.2344a5.4482,5.4482,0,0,1-4.8367,3.0023,5.4186,5.4186,0,0,1-5.0248-2.948c-.1805-.3116-.3062-.3639-.6562-.2557a5.6745,5.6745,0,0,1-7.0682-4.2061A5.8,5.8,0,0,1,2.8623,22.2615Z",
    fill: "#cae9ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0423,21.6236a1.05,1.05,0,0,1-.7931-.351c-1.1846-1.1839-2.3723-2.3646-3.55-3.5555a1.114,1.114,0,1,1,1.5851-1.5637c.7788.7626,1.56,1.5243,2.309,2.3151.2727.2878.3649.21.5518-.0728,1.7891-2.7031,3.5937-5.396,5.39-8.0946a1.1594,1.1594,0,0,1,.8109-.5849,1.07,1.07,0,0,1,1.1356.4931,1.0988,1.0988,0,0,1-.0351,1.2733q-1.0151,1.5262-2.036,3.0485Q17.243,17.7794,15.0785,21.03A1.1486,1.1486,0,0,1,14.0423,21.6236Z",
    fill: "#3b3b3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.26b75c9f69097db49855a9563cd2099d.svg";
export { ForwardRef as ReactComponent };